import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import Home from "@/pages/Home";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import BookingConfirmation from "@/pages/BookingConfirmation";

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-[#060709] text-[#f4f4f7] min-h-screen selection:bg-[#c9a24d] selection:text-black">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/paiement/succes" element={<PaymentSuccess />} />
            <Route path="/paiement/annule" element={<PaymentCancel />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/confirmation/:id" element={<BookingConfirmation />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" />
      </div>
    </LanguageProvider>
  );
}

export default App;
